<template>
  <div class="vcreator18-collection">
    <div class="vcreator18-template" :class="{ no_permission: !component.permission_value }">
      <button
        class="v17-knob"
        @mouseenter="tooltipVisible = true"
        @mouseleave="tooltipVisible = false"
      >
        <f-icon :icon="component.icon"></f-icon>
        <f-icon icon="plus"></f-icon>
      </button>
      <div class="source-title">{{ component.title }}</div>
      <div
        v-if="component.tooltip && component.permission_value"
        class="v18-vcreator-source-tooltip"
        :class="{ visible: tooltipVisible }"
        v-html="component.tooltip"
      ></div>
      <div
        v-if="component.no_permission_message && !component.permission_value"
        class="v18-vcreator-source-tooltip"
        :class="{ visible: tooltipVisible }"
        v-html="component.no_permission_message"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  translate25Context: 'vcreator18',
  props: {
    component: Object,
    handler: Object,
  },
  data() {
    return {
      tooltipVisible: false,
    }
  },
}
</script>
